// Lançamento e listagem de gastos do viajante.

export const pt = {
  newTitle: 'Novo gasto',
  newSubtitle: 'Guardado no aparelho e sincronizado quando houver conexão.',
  descricao: 'Descrição',
  descricaoPlaceholder: 'ex.: Combustível, hospedagem…',
  valor: 'Valor',
  submit: 'Guardar gasto',
  emptyList: 'Nenhum gasto lançado ainda',
  noPhoto: 's/ foto',
  discard: 'Descartar',
  errors: {
    descricao: 'Descreva o gasto (ex.: combustível, hospedagem)',
    valor: 'Informe um valor válido (ex.: 150,00)',
    save: 'Não foi possível guardar o gasto',
  },
  status: {
    synced: 'Sincronizado',
    pending: 'Pendente',
    syncing: 'Enviando…',
    failed: 'Falhou',
  },
  photo: {
    label: 'Foto do comprovante (opcional)',
    alt: 'Comprovante',
    change: 'Trocar foto',
    remove: 'Remover',
    take: 'Tirar foto',
    error: 'Não foi possível processar a foto. Tente de novo.',
  },
};

export const es: typeof pt = {
  newTitle: 'Nuevo gasto',
  newSubtitle: 'Guardado en el dispositivo y sincronizado cuando haya conexión.',
  descricao: 'Descripción',
  descricaoPlaceholder: 'ej.: Combustible, alojamiento…',
  valor: 'Importe',
  submit: 'Guardar gasto',
  emptyList: 'Ningún gasto registrado aún',
  noPhoto: 's/ foto',
  discard: 'Descartar',
  errors: {
    descricao: 'Describa el gasto (ej.: combustible, alojamiento)',
    valor: 'Ingrese un importe válido (ej.: 150,00)',
    save: 'No se pudo guardar el gasto',
  },
  status: {
    synced: 'Sincronizado',
    pending: 'Pendiente',
    syncing: 'Enviando…',
    failed: 'Falló',
  },
  photo: {
    label: 'Foto del comprobante (opcional)',
    alt: 'Comprobante',
    change: 'Cambiar foto',
    remove: 'Quitar',
    take: 'Tomar foto',
    error: 'No se pudo procesar la foto. Inténtelo de nuevo.',
  },
};
